import { createContext, ReactNode, useContext, useMemo } from 'react';

export interface Store {
  patientId?: number;
}

const StoreContext = createContext<Store>({});

export interface StoreProviderProps extends Store {
  children: ReactNode;
}

export const StoreProvider = ({ patientId, children }: StoreProviderProps) => {
  const value = useMemo(() => ({ patientId }), [patientId]);

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
